export default {
  data() {
    return {
      loadingConfig: {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      },
    }
  },
  methods: {
    loadingOpen() {
      if (this.loadingInstance) return true
      this.loadingInstance = this.$loading(this.loadingConfig)
      return false
    },
    loadingClose() {
      if (this.loadingInstance) this.loadingInstance.close()
      this.loadingInstance = null
    },
  },
}
